module.exports = __webpack_public_path__ + "img/alternative_logo.44d3193a.png";